import { Injectable, signal } from '@angular/core';
import { ChannelApiService } from '../api';
import { Channel, UpdateChannelPayload } from '../models';
import { Observable, tap } from 'rxjs';
import { SubscriblyStatusService } from './subscribly-status.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  channels = signal<Channel[]>([]);

  constructor(
    private channelsApiService: ChannelApiService,
    private subscriblyStatus: SubscriblyStatusService,
  ) {}

  getChannels(workspaceId: string): Observable<Channel[]> {
    return this.subscriblyStatus
      .withFallback(
        () => this.channelsApiService.getChannels(workspaceId, true),
        () => this.channelsApiService.getChannels(workspaceId, false),
      )
      .pipe(
        tap((channels) => {
          this.channels.set(channels ?? []);
        }),
      );
  }

  updateChannel(
    channelId: string,
    payload: UpdateChannelPayload,
  ): Observable<Channel> {
    return this.channelsApiService.updateChannel(channelId, payload).pipe(
      tap((channel) => {
        this.channels.update((channels) =>
          channels.map((item) => (item.id === channel.id ? channel : item)),
        );
      }),
    );
  }

  deleteChannel(channelId: string): Observable<Channel> {
    return this.channelsApiService.deleteChannel(channelId).pipe(
      tap((channel) => {
        this.channels.update((channels) =>
          channels.filter((item) => item.id !== channel.id),
        );
      }),
    );
  }
}
